// 老师端-实践资源库
import services from '../assets/js/services'

export default {
  state: {
    schoolTrainCourse: null, // 课程列表（筛选项）
    schoolTrainChapter: null, // 课程章节列表（筛选项）
    schoolCategory: null, // 实验基地/数字展馆 分类列表
  },
  getters: {
  },
  actions: {
    // 获取课程学习资源列表
    getCourseResource (context, payload) {
      return services.getCourseResource(payload).then(res => {
        return res;
      })
    },
    // 获取课程数字展馆列表
    getCourseHall (context, payload) {
        return services.getCourseHall(payload).then(res => {
            return res;
        })
    },
    // 获取课程实验基地列表
    getCourseStudyHub(context, payload) {
        return services.getCourseStudyHub(payload).then(res => {
            return res;
        })
    },
    // 获取课程试题列表
    getCourseQuestion(context, payload) {
        return services.getCourseQuestion(payload).then(res => {
            return res;
        })
    },
    // 获取课程试题详情
    getCourseQuestionDetail(context, payload) {
        return services.getCourseQuestionDetail(payload).then(res => {
            return res;
        })
    },
    // 教师端-获取课程列表（筛选项）
    getSchoolTrainCourse(context, payload) {
      return services.getSchoolTrainCourse(payload).then(res => {
        if (res.code == '0000') {
          if(res.data){
            context.commit('setSchoolTrainCourse', {
              'data': res.data ? res.data : {}
            })
          }
        }
        return res;
      })
    },
    // 教师端-课程章节列表（筛选项）
    getSchoolTrainChapter(context, payload) {
      return services.getSchoolTrainChapter(payload).then(res => {
        if (res.code == '0000') {
          if(res.data){
            context.commit('setSchoolTrainChapter', {
              'data': res.data ? res.data : {}
            })
          }
        }
        return res;
      })
    },
    // 获取实验基地/数字展馆 分类列表
    getSchoolCategory (context, payload) {
      return services.getSchoolCategory(payload).then(res => {
        if (res.code == '0000') {
          if(res.data){
            context.commit('setSchoolCategory', {
              'data': res.data ? res.data : {}
            })
          }
        }
        return res;
      })
    },
  },
  mutations: {
    setSchoolTrainCourse (state, payload) {
      state.schoolTrainCourse = payload.data;
    },
    setSchoolTrainChapter (state, payload) {
      state.schoolTrainChapter = payload.data;
    },
    setSchoolCategory (state, payload) {
      state.schoolCategory = payload.data;
    },
  }
}